<!-- components/RouterLinkButton.vue -->
<template>
    <router-link :to="to" custom v-slot="{ href, navigate }">
        <a :style="{ fontSize: fontSize ? fontSize + 'px' : null }" :href="disabled ? null : href" :target="target"
            class="el-button el-button--text el-button--mini"
            :class="{ 'is-disabled': disabled }"
            @click="(e) => handleClick(e, navigate)">
            <slot />
        </a>
    </router-link>
</template>

<script setup>
const props = defineProps({
    to: { type: [String, Object], required: true },
    target: { type: String, default: null },
    cb: { type: Function, default: null },
    fontSize: { type: [Number, String], default: '12' },
    disabled: { type: Boolean, default: false }
})

function handleClick(e, navigate) {
    if (props.disabled) {
        e.preventDefault()
        return
    }
    if (props.target === '_blank') {
        // Opens in new tab via href — just fire the callback, don't navigate()
        if (props.cb) props.cb()
        return
    }
    // In-app navigation
    if (
        e.button === 0 &&
        !e.ctrlKey && !e.metaKey &&
        !e.shiftKey && !e.altKey
    ) {
        e.preventDefault()
        navigate(e)
        if (props.cb) props.cb()
    }
}
</script>
